import React, { useEffect, useState } from 'react';

const REFRESH_INTERVAL_MS = 60 * 1000;

const Kiosk = () => {
  const [cacheKey, setCacheKey] = useState(Date.now());
  const [hasImage, setHasImage] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCacheKey(Date.now());
      setHasImage(true);
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  const imageSrc = `/api/indstillinger/kiosk/image?v=${cacheKey}`;

  return (
    <div className="w-screen h-screen bg-black overflow-hidden">
      <div className="w-full h-full flex items-center justify-center">
        {hasImage ? (
          <img
            src={imageSrc}
            alt="Kiosk"
            className="w-full h-full object-contain"
            onError={() => setHasImage(false)}
          />
        ) : (
          <div className="text-center text-white px-6">
            <h1 className="text-2xl font-semibold mb-2">Ingen kiosk-billede</h1>
            <p className="text-sm text-gray-300">Upload et billede under Indstillinger → Kiosk.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Kiosk;
